import { Nullable } from '@/utils/types';

// Memoised at module scope so every chart component shares one in-flight (or resolved)
// import of the (334 KB) echarts chunk, instead of each mounted chart re-triggering its own.
let echartsPromise: Nullable<Promise<typeof import('echarts')>> = null;

export const loadEcharts = (): Promise<typeof import('echarts')> => (echartsPromise ??= import('echarts'));
